module.exports = __webpack_public_path__ + "img/65.d5dd191f.jpg";